import { Feature, PermanentFeature } from "~/shared/util/feature"
import { hideInternalFeatures } from "~/shared/util/showInternalFeatures"
import viewManager from "~/shared/util/viewManager"

export { Feature, PermanentFeature }

const INTERNAL_FEATURES: Set<Feature | PermanentFeature> = new Set([
  Feature.InternalFeatures,
])

export function isFeatureEnabled(feature: Feature | PermanentFeature): boolean {
  if (hideInternalFeatures() && INTERNAL_FEATURES.has(feature)) {
    return false
  }
  return viewManager.get("features")[feature]
}

// Returns the numeric value of a multivariate Harness feature flag as
// resolved by the backend (see Gating::NUMERIC_MULTIVARIATE_FLAGS in
// lib/gating.rb). Returns undefined when the flag is not numeric, not
// configured, or its Split treatment is missing/non-numeric/non-positive.
// Callers should apply their own per-flag default when undefined is
// returned.
export function getFeatureNumber(
  feature: Feature | PermanentFeature,
): number | undefined {
  const value = viewManager.get("featureNumbers")[feature]
  return typeof value === "number" && Number.isFinite(value) ? value : undefined
}
